var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Avatar, AvatarLetter, AvatarList, Skeleton, TableBodyCell, TableCellEmpty, UserAvatar, } from '@pocketlaw/tetris';
import { useUsers } from './useUsers';
export function UsersCell(props) {
    const { userIds } = props, rest = __rest(props, ["userIds"]);
    const safeValue = userIds || [];
    const userIdArray = Array.isArray(safeValue) ? safeValue : [safeValue];
    const { users, loading } = useUsers(userIdArray);
    if (loading) {
        return (<TableBodyCell {...rest}>
        <Skeleton loading borderRadius="circle">
          <Avatar size="sm" shape="circle" appearance="light">
            <AvatarLetter>?</AvatarLetter>
          </Avatar>
        </Skeleton>
      </TableBodyCell>);
    }
    if (!users.length) {
        return (<TableBodyCell {...rest}>
        <TableCellEmpty />
      </TableBodyCell>);
    }
    return (<TableBodyCell {...rest}>
      <AvatarList>
        {users.map((user) => (<UserAvatar key={user.id} title={user.name}/>))}
      </AvatarList>
    </TableBodyCell>);
}
